export default {
    'translation': {

        // 소비자 앱
        'insert_security_code' : '输入授权代码',
        'valid_security_code' : '这是有效的批准代码（认证次数：{{count}}）',
        'security_code' : '授权代码',
        'confirm': '确认',
        'expired_authentication': '此产品为验证期间已经过期',
        'product_not_exist': '不存在的产品',
        'product_not_exist_detail': '请再次尝试认证或咨询制造商',
        'contact_customer_center': '请联系服务中心了解更多详细信息',
        'authenticating': '正在验证',
        'wait_moment': '请稍等',
        'authentication_result': '验证结果',
        'authenticated': '已验证的代码',
        'manufacturer': '品牌',
        'distribution_details': '流通交收记录',
        'scan_list': '认证历史',
        'product_detail': '产品信息',
        'distribution_history': '流通记录',
        'hash_tags': '哈希标签',
        'shop_tags': "商城网址",
        'company_tags': "公司官网",
        'no_hashtags': "没有指定的标签。",
        'no_shopurl': "没有商城网址。",
        'no_companyurl': "没有公司官网。",
        'has_event': ' 正在进行活动！',
        'app_benefit_1': '请安装m-check APP并验证产品后，',
        'app_benefit_2': '可以得到很多优惠。',
        'app_benefit_3': '安装APP，参加活动！',
        'download_app': '安装APP',
        'view_on_web': '用手机看网页',
        'incorrect_code': '验证错误',
        'cant_find_code': "无法验证代码",
        'check_code_again': "请重新确认产品代码",
        'inserted_code': "您输入的代码",
        'contact_customer_center_error': "如果重新确认也出现错误代码警告时，请联系您购买产品的商店或者服务中心",
        'select_product_place': "请选择产品购买的地点",
        'to_improve_service': "本调查旨在作为改善产品和服务问题的资源",
        'submit_survey': "提交",
        'touch_object': "您触摸3D物体时，视频将会播放",
        'scan_qr_code': "请扫描二维码",
        'no_authentication': "没有验证记录",
        'welcome': "欢迎！",
        'login_benefit': "登录的顾客可以拿到多种多样的优惠！",
        'facebook_login': "Facebook登录",
        'line_login': "Line登录",
        'weibo_login': "微博登录",
        'close': "关闭",
        'product_code': "关闭",
        'product_info': "查看产品信息",
        'authenticationi_list': "验证记录",
        'events_you_won': "中奖",
        'sorry': "抱歉",
        'once_per_id': "每个ID只能参加一次！",
        'ok': "确认",
        'closed_event': "活动结束",
        'wait_for_next_event': "请等一下下一次活动",
        'lotto_void_message': '下次见',
        'event_result': "活动结果",
        'find_in_authentication_detail': "活动领取的条形码可以再验证记录上确认",
        'you_win': "中奖啦！",
        'turn_roulette': "玩转轮盘！",
        'scratch_lotto': "请刮刮彩票！",
        'sns_login': "SNS 登录",
        'login_required_for_event': "为了参加活动，\n需要登录SNS",
        'turn_on_light': "在黑暗的地方，\n请开灯后验证。",
        'scan_qr_or_tag_nfc': "请扫描二维码或者接触NFC标记来验证。",
        'check_3d_modeling': "通过AR扫描,\n可以确认产品的3D模式！",
        'check_through_authentication': "通过验证结果，\n可以查看产品品牌信息和详细信息。",
        'check_first_authentication': "通过验证次数确认你是否第一个验证者!",
        'check_the_way_distributed': "可以确认流通渠道。",
        'scroll_to_check_detail': "向下滚动查看产品详细信息！",
        'participate_for_benefit': "参加活动并领取礼品！",
        'log_in': "登录",
        'register': "注册",

        // CMS
        'id': "用户名",
        'password': "密码",
        'enter_id': "请输入用户名",
        'enter_password': "请输入密码",
        'company_login': "公司登录",
        'admin_login': "ADMIN 登录",
        'statistics': "统计",
        'member_management': "会员管理",
        'product_management': "产品管理",
        'track_trace_management': "流通关系",
        'operation_management': "运作管理",
        'issue_codes': "发行代码",
        'statistics_overview': "OVERVIEW",
        'statistics_by_manufacturer': "按品牌统计",
        'statistics_by_products': "按产品统计",
        'by_manufacturer': "品牌",
        'by_distributor': "流通商",
        'by_customer': "消费者",
        'company_info': "公司信息",
        'product': "产品管理",
        'event': "活动管理",
        'track_trace': "运作管理",
        'abnormal_authentication': "异常信息",
        'abnormal_location': "异常信息购买处查询",
        'admin_member': "ADMIN 会员",
        'push_message': "Push 通知",
        'recent_year': "近1年统计",
        'total_manufacturer': "品牌总数",
        'total_product': "总产品群",
        'total_tags': "总发行数量",
        'total_authentication': "总验证数量",
        'top5_by_country': "国别验证率 TOP5",
        'top5_by_product': "产品验证率 TOP5",
        'country_name': "国家名",
        'authentication_rate': "验证率",
        'product_name': "产品名",
        'statistics_by_map': "地图验证统计",

        'register_company': "制造商登录",
        'company_search_keyword': "制造商名/制造商#/账户",
        'search': "查询",
        'total': "总共",
        'selected_member_status': "选择会员的状态",
        'change': "变更",
        'normal': "正常",
        'block': "中断",
        'select': "选择",
        'country': "国家",
        'company_logo': "Logo",
        'company_name': "公司",
        'ID': "ID",
        'member_in_charge': "经办人",
        'status': "状态",
        'registered_date': "登录日",
        'register_distributor': "流通者登记",
        'distributor_search_keyword': "名字/账户",
        'affiliate': "所属联合公司",
        'customer_search_keyword': "国家/名字/账户",
        'customer_name': "名字",
        'customer_center': "服务中心",
        'company_register': "登记",
        'company': "公司",
        'company_code': "会员代码",
        'address': "地址",
        'contact': "联系方式",
        'person_in_charge': "经办人",
        'contact_number': "经办人联系方式",
        'brand_logo': "品牌Logo",
        'upload_file': "上传文件",
        'preview': "预览",
        'recommended_image_size': "图片建议规格 ： 1080px*216px / 0.5MB 以下, .pngpek160114_273, .gif, .svg 透明背景",
        'business_license': "营业执照",
        'bank_account_copy': "账本复印件",
        'telephone': "电话",
        'operation_time': "运营时间",
        'edit': "修改",
        'distributor': "流通者",
        'product_list': "产品记录",
        'product_number': "产品 #",
        'number_of_authentication': "验证数量",
        'contacts': "联系方式",
        'select_affiliate': "选择合作商",
        'distributor_info': "流通者信息",
        'name': "名字",
        'person_in_charge_affiliate': "经办人",
        'manufacturing_date': "制造日",
        'authentication_location': "验证位置",
        'authentication_date': "验证日",
        'authentication_history': "验证记录",
        'attached_events': "中奖",
        'customer_info': "消费者信息",
        'email': "电邮",
        'gender': "性别",
        'birth_year': "生日",
        'event_type': "活动种类",
        'event_name': "活动名称",
        'items': "items",

        'unauthorized': "拒绝",
        'approval': "批准",
        'stop': "停止",
        'expiration': "满期",
        'request': "申请批准",
        'product_register': "产品登记",
        'product_search_keyword': "公司名/产品#/产品名",
        'selected_product_status': "选择的产品状态",
        'design_settings': "设计设置",
        'set_language_as_default': "将语言设置为基本页面",
        'representative_image': "代表图案",
        //// 신규 추가
        'admin_product_product_name_placeholder': '产品名',
        'admin_product_add_image_box': `添加<br/>图案`,
        'admin_product_hashtag_placeholder': `#Hashtag`,
        'admin_product_authentication_placeholder': `验证次数（最多40个）`,
        'admin_product_3d_model_placeholder': `文件规格2MB以下(.glb)`,
        'admin_product_bgm_placeholder': `文件规格2MB以下(.mp3, .acc)`,
        'admin_product_video_placeholder': `视频规格50MB以下(.avi, .mp4)`,
        ////////////
        'add_image': "图案",
        'add_image_br': "图案",
        'recommended_representative_images': "代表图案推荐规格：1080px*786px, 大小 0.5MB\n 以下最多可登记10个",
        'detailed_information': "详细信息",
        'recommended_detailed_image': "详细信息图案推荐规格：横向 1080px,大小0.5MB 以下",
        'tag': "Tag",
        'authentication_information': "验证信息",
        'maximum_number_of_authentication': "最多验证次数",
        'regardless_number_of_authentication': "-1的话，不管验证次数可连续验证",
        'magnetic_authentication_guide': "磁铁验证指南",
        'connection_url': "链接URL",
        'authentication_period': "验证期间",
        'start_date': "开始日",
        'expiration_date': "满期日",
        '3d_model': "3D 模式",
        'recommended_file_size': "文件规格20MB以下(.3dm, .3ds, CATpart, igs, .MODEL, .obj)",
        'video': "视频",
        'edit_feedback': "Feedback 编辑",
        'survey_title': "问卷调查 题目",
        'survey_contents': "问卷调查 内容",
        'survey_item': "问卷调查 项目",
        'input': "添加",

        'authentication_stage': "验证阶段",
        'genuine_mark': "正品表示",
        'layout': "版面设计",
        'authentication_stage_design': "验证阶段设计",
        'add_design': "加设计",
        'remove': "删除",
        'register_product': "产品登记",
        'setting_product_permissions': "设置产品权",
        'basic_authentication': "基本验证",
        'ar': "AR",
        'survey': "问卷调查",
        'lottery': "彩票",
        'roulette': "转轮盘",
        'sample_product_qr_code': "样品二维码",
        'download_qr': "下载二维码",
        'copy_qr_link': "复制二维码链接",
        'image_recommendation_specification': "图片建议规格 ： 600px*144px / 0.5MB 以下, .pngpek160114_273, .gif, .svg 透明背景",
        'genuine_mark_design': "正品表示设计",
        'register_event': "登记活动",
        'event_search_keyword': "联合公司/产品#/产品名",
        'selected_event_status': "选择活动的状态",
        'type': "种类",
        'event_information': "活动信息",
        'event_image': "活动图片",

        'attach_event_image': "上传活动图片",
        'enter_url': "输入URL",

        'event_image_specification': "图案规格 1080px*1920px, 0.5MB 以下、",
        'event_link': "活动链接",
        'event_info': "活动信息",
        'event_period': "活动期间",
        'time': "时间",
        'event_title': "活动题目",
        'maximum_15_characters': "包括分写最多15个字",
        'maximum_21_characters': "包括分写最多21个字",
        'number_of_goods': "商品数量",
        'two_divisions': "分成2个",
        'three_divisions': "分成3个",
        'quadrant': "分成4个",
        'five_divisions': "分成5个",
        'six_divisions': "分成6个",
        'product_type': "商品种类",
        'prize_name': "商品名",
        'product_description': "商品说明",
        'maximum_byte': "最多 18 byte",
        'probability': "概率",
        'acceptable_probability': "可输入0.001%-99%",
        'commodity_quantity': "商品数量",
        'change_to_zero_probability': "消耗殆尽时，概率变更到0",
        'promotion_code': "推销代码",
        'promotion_code_or_barcode': "推销代码/条形码",
        'barcode_image': "条形码图案",
        'fail': "未中奖",
        'image': "图案",
        'text': "原文",
        'prize_image_specification': "（规格 480px*318px)，文件0.5MB 以下",

        'period': "期间",
        'specifying_distributor': "流通者指定",
        'download_excel': "下载Excel",
        'product_group': "产品群",
        'quantity': "数量",
        'select_product': "选择产品",
        'register_manufacturing_sites': "登记制造地点",
        'optional': "Optional",
        'add': "添加",
        'search_address': "探索地址",
        'setting_authentication_period': "设置可验证时间",
        'specifying_authentication_zone': "指定验证地点",
        'view_map': "查看地图",
        'undesignated': "未指定",
        'cut_off': "阻断",
        'many_positions': "多位置",
        'a_number_of_authentications': "多验证",
        'abnormal_authentication_statistics': "非正常验证统计",
        'place_of_purchase': "购买处",
        'register_admin': "ADMIN 登记",
        'authorization': "权限",
        'member_level': "会员等级",
        'completed': "完成！",
        'message': "通知",
        'including_box_codes': "包括BOX代码",
        'individual_product': "个别产品",
        'automatic': "自动",
        'number_of_digits': "位数",
        'manual': "手动",
        'upload_excel_file': "Excel上传",
        'number_of_individual_products': "个别产品数量",
        'box_level': "BOX 水平",
        'box_ea': "BOX 数量",
        'box_capacity': "BOX 一箱用量",
        'box_capacity_lv1': "BOX 一箱用量",
        'issue_codes_completed': "代码发行完成",
        'issue_codes_failed': "代码发行失败",
        'code_issue_info': "Excel文件每保存500,000个代码。",

        'manufacturing_history': "制造记录",
        'abnormal_authentication_history': "非正常验证记录",
        'number_of_authentications': "验证次数",
        'certifier': "验证人",

        'max_number_of_authentications': "验证次数（最多40个）",
        'recommended_music_file_size': "文件规格2MB以下(.mp3, .acc)",
        'recommended_video_file_size': "视频规格50MB以下(.avi, .mp4)",

        // 유통자 앱
        'for_distributor': "经销商服务",
        'forgot_password': "忘记密码？",
        'contact_company': "请联系制造商。",
        'login': "登录",
        'hello': "您好",
        'list_of_taking_over': "交接记录",
        'none_of_list': "None of list",
        'and': "and",
        'select_unit': "选择单位",
        'change_product_status': "更换产品状态",
        'change_box_status': "更换箱子状态",
        'hand_over': "交收",
        'take_over': "交接",
        'handover': "交收",
        'takeover': "交接",
        'product_authentication': "正品验证",
        'box': "箱",
        'individual': "产品单位",
        'working_box_unit': "以箱子为单位进行业务",
        'working_Individual_unit': "以产品单位进行业务。",
        'move_product': "产品移动",
        'move_product_to_another': "将产品移到另一箱子",
        'insert_product': "添加产品",
        'insert_product_to_this': "箱子里添加产品",
        'remove_product': "删除产品",
        'remove_product_from_this': "箱子里删除产品",
        'move_box_to_another_level': "将箱子移到另一箱子",
        'move_box_to_another_same_level': "将小箱子移到大箱子",
        'insert_box': "添加箱子",
        'insert_box_to_higher_level': "在大箱子里添加小箱子",
        'remove_lower_level_box': "删除箱子",
        'remove_lower_level_box_from_this': "在大箱子里删除小箱子",
        'cancel': "取消",
        'check': "确认",
        'complete': "成功",
        'takeover_list': "交收记录",
        'handover_list': "交接记录",
        'authentication_list': "正品验证记录",
        'distributed_handover_details': "流通交接记录",
        'distributed_takeover_details': "流通交收记录",
        'distributor_list': "流通商记录",
    }
}
